import PropTypes from 'prop-types'

export const BudgetTypes = {
  simple: 'simple',
  detailed: 'detailed',
}

export const budgetTypePropType = PropTypes.oneOf(
  Object.values(BudgetTypes)
)
